import React, { useState } from 'react';
import styles from './register.module.css';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';

const StepOne = ({ onSubmit }) => {
    const [state, setState] = useState({
        mobile: { name: 'mobile', value: '', error: '', isRequired: true },
        agree: false, // Checkbox state
    });

    const validateMobile = (value) => {
        // Validate mobile number format (10 digits)
        const mobileRegex = /^[0-9]{10}$/;
        if (!mobileRegex.test(value)) {
            return 'Mobile number must be 10 digits';
        }
        return ''; // No error
    };

    const validateForm = () => {
        let isValid = true;

        // Validate mobile field
        if (!state.mobile.value) {
            setState((prevState) => ({
                ...prevState,
                mobile: {
                    ...prevState.mobile,
                    error: 'Mobile number is required',
                },
            }));
            isValid = false;
        } else {
            const mobileError = validateMobile(state.mobile.value);
            if (mobileError) {
                setState((prevState) => ({
                    ...prevState,
                    mobile: {
                        ...prevState.mobile,
                        error: mobileError,
                    },
                }));
                isValid = false;
            }
        }

        // Validate checkbox agreement
        if (!state.agree) {
            // alert('You must agree to the Privacy Policy and Terms & Conditions');
            isValid = false;
        }

        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            const payload = {
                mobile: state.mobile.value,
            };
            onSubmit(payload); 
        } else {
            console.log('Form validation failed');
        }
    };

    const handleMobileChange = ({ formattedValue, value }) => {
        // Remove the error dynamically as the user types
        const error = validateMobile(value);
        setState((prevState) => ({
            ...prevState,
            mobile: {
                ...prevState.mobile,
                value: value, // Update the mobile value
                error: error, // Remove error if valid
            },
        }));
    };

    return (
        <React.Fragment>
            <form className={`${styles['reg-box']} card`} onSubmit={(e) => handleSubmit(e)}>
                <div className={`${styles['reg-body']} card-body`}>
                    <h5 className={`${styles['reg-title']}`}>Register with your mobile number</h5>
                    <p className={`${styles['reg-text']}`}>Let's start with your mobile number.</p>
                    <div className='my-4'>

                    <NumberFormat
                        className={`form-control ${state.mobile.error ? 'is-invalid' : ''}`}
                        placeholder="Enter your number"
                        name={state.mobile.name}
                        value={state.mobile.value}
                        onValueChange={handleMobileChange}
                        format="+91 #####-#####"
                        mask="_"
                        allowEmptyFormatting={false}
                        prefix="+91 "
                    />
                    {state.mobile.error && (
                        <div className="invalid-feedback">{state.mobile.error}</div>
                    )}
                    </div>

                    <div className="form-check mb-3 d-flex align-items-center">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="agree"
                            checked={state.agree}
                            onChange={() => setState((prevState) => ({
                                ...prevState,
                                agree: !prevState.agree, // Toggle agree state
                            }))}
                        />
                        <label className="form-check-label ps-1" htmlFor="agree">
                            I Agree to JobzShala's
                            <a className={`${styles['link-text']} ps-1`} href="https://jobzshala.com/privacy-policy">
                                Privacy Policy
                            </a>
                            ,{' '}
                            <a className={`${styles['link-text']}`} href="https://jobzshala.com/termsconditions">
                                Terms & Conditions
                            </a>
                            , and Promotional Communication.
                        </label>
                    </div>
                    <button className={`${styles['send-btn']} btn w-100`} type="submit">
                        Send OTP
                    </button>
                    <p className={`${styles['acc-text']} text-center pt-3`}>
                        Already have an account?
                        <Link className={`${styles['link-text']} ps-2`} href={constant.component.login.url}>
                            Login Now
                        </Link>
                    </p>
                </div>
            </form>
        </React.Fragment>
    );
};

export default StepOne;
